import colorSet from './colorSet';
export default function colorScheme(baseColors, roleMapping, options) {
  const {
    colorMapping,
    noCache
  } = options !== null && options !== void 0 ? options : {};
  const colors = colorSet(baseColors, colorMapping, noCache);
  return roleMapping(colors);
}